import type Competence from "constants/Competence";

export interface Metier {
  code: string;
  libelle: string;
  competence?: Competence;
  niveau: MetierNiveau;
}

export enum MetierNiveau {
  Commune = "Commune",
  Perimetre = "Perimetre",
  Territoire = "Territoire",
}
